"use client"

import { useState } from "react"
import "./PropFaq.css"

const faqData = [
  {
    question: "What is the meaning of proptech?",
    answer:
      "PropTech, a blend of 'property' and 'technology,' refers to the use of information technology to help individuals and companies research, buy, sell, and manage real estate. It encompasses a wide array of digital tools, platforms, and technologies aimed at streamlining and enhancing the real estate market's efficiency and effectiveness.",
  },
  {
    question: "What is proptech and examples?",
    answer:
      "PropTech stands for Property Technology and involves the application of technology to real estate markets to solve traditional challenges and create new opportunities. Examples include:• Online real estate marketplaces• Virtual reality (VR) tours for property viewing• Smart home technology for automated property management• Blockchain for secure and transparent transactions• AI-driven platforms for property valuation and investment analysis",
  },
  {
    question: "Is proptech the future of real estate?",
    answer:
      "PropTech, a blend of 'property' and 'technology,' refers to the use of information technology to help indiYes, PropTech is widely regarded as the future of real estate. It offers innovative solutions that enhance efficiency, transparency, and sustainability in the real estate sector. By leveraging digital transformation, PropTech is set to redefine how properties are bought, sold, managed, and invested in, making the industry more accessible and user-friendly.viduals and companies research, buy, sell, and manage real estate. It encompasses a wide array of digital tools, platforms, and technologies aimed at streamlining and enhancing the real estate market's efficiency and effectiveness.",
  },
  {
    question:
      "What is the use of proptech?",
    answer:
      "The use of PropTech includes:• Simplifying property search and transaction process• Enhancing property management through automation and IoT device• Providing data-driven insights for better investment decision• Improving the leasing and buying experience with virtual tour• Facilitating secure and efficient transactions with blockchain technology",
  },
  {
    question: "What are the risks of proptech?",
    answer:
      "Risks of PropTech include:• Data privacy and security concerns• Dependence on technology leading to potential system failures or cyber-attacks• Regulatory and compliance challenges• Market saturation and the potential for bubbles in tech-driven real estate investments",
  },
  {
    question: "What is the purpose of proptech?",
    answer:
      "The purpose of PropTech is to:• Increase efficiency and reduce costs in real estate transactions and management• Enhance the user experience for buyers, sellers, renters, and managers• Provide more accurate and accessible data for decision-making• Promote sustainability and innovation in the real estate sector",
  },
  {
    question:
      "What role does AI plays in proptech?",
    answer:
      "AI plays a crucial role in Proptech by enabling predictive analytics for investment, automating property management tasks, enhancing customer service through chatbots, and providing personalized recommendations for buyers and renters.",
  },
]

const FAQSection = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section9021">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT</h1>
          <h2 className="sub-title">PROPTECH SOFTWARE DEVELOPMENT</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default FAQSection
